import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Reports|Newly Imported Exams|Details|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Exam,
	portal: 'SP',
};

type LocNameStart = 'SPReportsNewlyImportedExamsDetails';
export type SPReportsNewlyImportedExamsDetailsLocNames =
	| `${LocNameStart}TitleTab`
	| `${LocNameStart}TitlePage`
	| `${LocNameStart}TitleSection`
	| `${LocNameStart}LabelRegistrationNumber`
	| `${LocNameStart}LabelTestCenter`
	| `${LocNameStart}LabelExamCode`
	| `${LocNameStart}LabelImportSource`
	| `${LocNameStart}LabelCandidateId`;

export const spNewlyImportedExamsDetailsLocs: LocDefs<SPReportsNewlyImportedExamsDetailsLocNames> =
	{
		SPReportsNewlyImportedExamsDetailsTitleTab: {
			defaultValue: 'Newly Imported Exams Details',
			description: 'Tab Title',
			displayPath: `${pathStart}Tab Title`,
			displayType: 'Title',
			legacyName: 'Exam/Reporting.NewlyImportedExamsDetails.Title.TabTitle',
			...sharedProperties,
		},
		SPReportsNewlyImportedExamsDetailsTitlePage: {
			defaultValue: 'Newly Imported Exams Report',
			description: 'Page Title',
			displayPath: `${pathStart}Page Title`,
			displayType: 'Title',
			legacyName: 'Exam/Reporting.NewlyImportedExams.Title.PageTitle',
			...sharedProperties,
		},
		SPReportsNewlyImportedExamsDetailsTitleSection: {
			defaultValue: 'Newly Imported Exams',
			description: 'Section Title',
			displayPath: `${pathStart}Section Title`,
			displayType: 'Title',
			legacyName: 'Exam/Reporting.NewlyImportedExams.Title.SectionTitle',
			...sharedProperties,
		},
		SPReportsNewlyImportedExamsDetailsLabelRegistrationNumber: {
			defaultValue: 'Registration Number',
			description: 'Column heading for: Registration Number.',
			displayPath: `${pathStart}Registration Number`,
			displayType: 'Label',
			legacyName: 'Exam/Reporting.NewlyImportedExamsDetails.ColumnHeading.RegistrationNumber',
			...sharedProperties,
		},
		SPReportsNewlyImportedExamsDetailsLabelTestCenter: {
			defaultValue: 'Test Center',
			description: 'Column heading for: Test Center.',
			displayPath: `${pathStart}Test Center`,
			displayType: 'Label',
			legacyName: 'Exam/Reporting.NewlyImportedExamsDetails.ColumnHeading.TestCenter',
			...sharedProperties,
		},
		SPReportsNewlyImportedExamsDetailsLabelExamCode: {
			defaultValue: 'Exam Code',
			description: 'Column heading for: Exam Code.',
			displayPath: `${pathStart}Exam Code`,
			displayType: 'Label',
			legacyName: 'Exam/Reporting.NewlyImportedExamsDetails.ColumnHeading.ExamCode',
			...sharedProperties,
		},
		SPReportsNewlyImportedExamsDetailsLabelCandidateId: {
			defaultValue: 'Candidate ID',
			description: 'Column heading for: Candidate ID.',
			displayPath: `${pathStart}Candidate ID`,
			displayType: 'Label',
			legacyName: 'Exam/Reporting.NewlyImportedExamsDetails.ColumnHeading.CandidateId',
			...sharedProperties,
		},
		SPReportsNewlyImportedExamsDetailsLabelImportSource: {
			defaultValue: 'Import Source',
			description: 'Column heading for: Import Source.',
			displayPath: `${pathStart}Import Source`,
			displayType: 'Label',
			...sharedProperties,
		},
	};

export type SPReportsNewlyImportedExamsDetailsLocType =
	LocMap<SPReportsNewlyImportedExamsDetailsLocNames>;
